import styled from 'styled-components';
import { Image } from '@/shared/ui/image';

export const SearchInput = styled.input`
  &:focus-visible {
    outline: none;
    box-shadow: none;
    outline-offset: 0;
  }
  border-radius: 8px;
  background-color: #27262b;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 140%;
  background-image: ${(props) =>
    props.$focused || props.$searchValue
      ? 'url(/images/icons/search-icon-white.svg)'
      : 'url(/images/icons/search-icon.svg)'};
  background-size: 28px 28px;
  background-repeat: no-repeat;
  padding: 0px 40px;
  background-position: 8px center;
  border: none;
  color: #afafaf;
  width: 100%;
  height: 48px;

  @media (max-width: 768px) {
    height: 42px;
  }
  //@media (orientation: landscape) {
  //  height: 40px;
  //}
  &::placeholder {
    color: #afafaf;

    /* @media (max-width: 768px) {
      visibility: hidden;
    } */
  }
  /* @media (max-width: 768px) {
    position: absolute;
    width: ${(props) => (props.$focused ? '100%' : '40px')};
    z-index: ${(props) => (props.$focused ? '1' : '0')};
    background-color: #27262B;
    box-shadow: 0px 1px 1px 0px rgba(239, 241, 243, 0.08) inset;
    padding: 12px;
    padding-left: ${(props) => (props.$focused ? '48px' : '12px')};
    padding-right: ${(props) => (props.$focused ? '48px' : '0px')};
    height: 40px;
    background-position: 7px center;
  } */
`;

export const InputWrapper = styled.div`
  position: relative;
  z-index: 1;
  /* @media (max-width: 768px) {
    margin:0 16px;
  } */
`;
export const ImageElement = styled(Image)`
  position: absolute;
  z-index: 100;
  right: 16px;
  top: 12px;
  cursor: pointer;

  @media (max-width: 768px) {
    top: 10px;
    right: 12px;
  }
`;

export const ImageElementWrapper = styled.div`
  z-index: 10;
`;
